module.exports = __webpack_public_path__ + "static/img/5.25d0bf0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/layer5/nav-1/5.jpg
// module id = gkP3
// module chunks = 0